import React from 'react';
import classNames from 'classnames';

function OverviewHeaderViewTemplate ({ helpers }) {

	const {
		hideViewMoodBoard, isCustomerService, showCartLink, showSkuOnTheFly
	} = helpers;

	const regionViewMoodBoardTopClassName = classNames(hideViewMoodBoard && 'hidden');

	return (
		<>
			<ul className="cartOptions cartOptionsCsr unstyledList">
				<li id="regionPrintCartLinkOverviewHeader" />
				<li>
					<button type="button" className="jsEmail anchorLink">
						Email
					</button>
				</li>
				{showCartLink && (
					<li>
						<button type="button" className="jsCartLink anchorLink">
							Cart Link
						</button>
					</li>
				)}
				<li>
					<button type="button" className="anchorLink" data-option="import">
						Import
					</button>
				</li>
				<li>
					<button type="button" className="anchorLink" data-option="delete">
						Delete
					</button>
				</li>
				<li className="customerInfoBtnContainer">
					<button type="button" className="anchorLink" data-option="info">
						Customer Info
					</button>
				</li>
				<li className="headerAddBulbsContainer jsAddBulbsContainer hidden">
					<button type="button" className="jsAddBulbs anchorLink">
						Add Bulbs
					</button>
				</li>
				<li id="regionViewMoodBoardTop" className={regionViewMoodBoardTopClassName} />
			</ul>
			{isCustomerService && showSkuOnTheFly && (
				<div className="skuOnTheFly group">
					{isCustomerService && <div className="addSkuContainer fl" id="addSkuContainer" />}
					{showSkuOnTheFly && (
						<div className="skuOnFlyContainer fl" id="skuOnFlyContainer">
							<button
								type="button"
								className="anchorLink"
								data-src="/sku-on-the-fly?SkuType=Product"
								aria-haspopup="true"
							>
								Create New SKU
							</button>
						</div>
					)}
				</div>
			)}
		</>
	);

}

export default OverviewHeaderViewTemplate;
